import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL || "/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // ✔ si tu utilises cookies / sessions côté backend
});

/* ----------------------------------------------------
  🔐 INTERCEPTEUR REQUEST : ajoute automatiquement le JWT
----------------------------------------------------- */
apiClient.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("authToken") ||
    sessionStorage.getItem("authToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

/* ----------------------------------------------------
  ❗ INTERCEPTEUR RESPONSE : gère erreurs globales
----------------------------------------------------- */
apiClient.interceptors.response.use(
  (response) => response, // ✅ Réponse OK → on laisse passer

  (error) => {
    // Aucune réponse = backend down / CORS / timeout
    if (!error.response) {
      console.error("Erreur réseau :", error);
      return Promise.reject({
        message: "Impossible de contacter le serveur.",
        details: error.message,
      });
    }

    const { status } = error.response;
    const url = error.config?.url || "";

    // 🛡️ Routes qui NE doivent PAS déclencher de redirection auto sur /login
    const safeAuthPaths = [
      "/users/register",
      "/users/check-email",
      "/users/login",
      "/auth/google/callback",
    ];

    const isSafeAuthRoute = safeAuthPaths.some((path) =>
      url.includes(path)
    );

    // 401 : Token expiré → redirection seulement pour les vraies routes protégées
    if (
      status === 401 &&
      window.location.pathname !== "/login" &&
      !isSafeAuthRoute
    ) {
      console.warn("401 détecté → redirection vers /login (route protégée)");
      window.location.href = "/login";
    }

    return Promise.reject(error); // ✔ On laisse l’erreur complète au composant
  }
);

export default apiClient;
